import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const UpdateMonthlyQuotaSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      amount: requiredString(t),
    })
    .strict();

export type UpdateMonthlyQuotaType = z.infer<ReturnType<typeof UpdateMonthlyQuotaSchema>>;
